import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { env } from '@/shared/config/env';
import type { ThemeMode } from '@/shared/domain/types';

export interface ThemeState {
  mode: ThemeMode;
}

const themeSlice = createSlice({
  name: 'theme',
  initialState: { mode: env.defaultTheme } as ThemeState,
  reducers: {
    setThemeMode(state, a: PayloadAction<ThemeMode>) {
      state.mode = a.payload;
    },
  },
});

export const { setThemeMode } = themeSlice.actions;
export const themeReducer = themeSlice.reducer;
